module.exports = __webpack_public_path__ + "static/media/wse_icon_hr.008913a0.svg";